<template>
  <div class="ModalLogout">
    <h4>Sign out of Emergency Assistance?</h4>

    <p>Are you sure you want to sign out of Emergency Assistance? Your progress will be saved, and you can resume your application at any time.</p>
    <div class="buttons">
      <b-button variant="primary" id="btn-logout" @click="logout">Sign out</b-button>
    </div>
  </div>
</template>

<script>
const hideResumeFromEmailLinkRoutes = ['ExistingApplication', 'PilotView']

export default {
  name: 'ModalLogout',
  methods: {
    logout() {
      this.$store
        .dispatch('logout')
        .then(() => {
          this.$store.dispatch('closeModal')
          this.$router.history.push({
            name: 'LogoutView',
            params: {
              hideResumeFromEmailText:
                hideResumeFromEmailLinkRoutes.indexOf(
                  this.$router.currentRoute.name
                ) !== -1
            }
          })
        })
        .catch(() => {
          this.$store.dispatch('closeModal')
          this.$store.dispatch('set', [
            'error',
            new Error('Error when signing out: Could not reach server')
          ])
          this.$router.history.push('/error')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.ModalLogout {
  padding: 1rem 2rem;
  h4 {
    margin-bottom: 2rem;
    color: $color-primary;
    font-weight: bold;
    font-size: 22px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;

    .btn {
      margin: 1rem 0 0;
      border: none;
      border-radius: 0.25rem;
      font-size: 1.6rem;
      background-color: $color-primary;
    }
  }
}
</style>
